import React from 'react';
import { useStyletron } from 'baseui';
import { Panel } from 'baseui/accordion';

import ENGTAccordion from 'components/UI/ENGTAccordion/ENGTAccordion';

import { IObjProps } from 'shared/consts/types';

export interface IAccordionNavSection {
	id: string;
	items: IObjProps;
	title: string;
}

export const isAccordionNavSection = (value: unknown): value is IAccordionNavSection =>
	!!value &&
	typeof value === 'object' &&
	'title' in value &&
	'items' in value &&
	typeof (value as IAccordionNavSection).title === 'string' &&
	typeof (value as IAccordionNavSection).items === 'object';

interface IAccordionNavGroupProps {
	children: React.ReactNode;
	id: string;
	isExpanded: boolean;
	onChange: (args: { expanded: string[] }) => void;
	title: string;
}

const AccordionNavGroup = ({ children, id, isExpanded, onChange, title }: IAccordionNavGroupProps) => {
	const [css, theme]: any = useStyletron();

	return (
		<ENGTAccordion
			expandedPanel={isExpanded ? id : ''}
			onChange={onChange}
			overrides={{
				root: {
					borderTopWidth: 0,
					borderTopStyle: 'none',
				},
				header: {
					paddingTop: '1rem',
					paddingRight: '0rem',
					paddingBottom: '0.5rem',
					paddingLeft: '0rem',
					borderBottom: 'none',
					fontWeight: 400,
				},
				content: {
					opacity: 0,
					padding: '0rem',
					overflowY: 'hidden',
					transitionProperty: 'max-height, height, opacity',
					transitionDuration: theme.animation.timing700,
					transitionTimingFunction: theme.animation.easeInOutCurve,
				},
				expanded: {
					content: {
						borderBottom: 'none',
						opacity: 1,
						padding: '0rem',
						overflowY: 'hidden',
						transitionProperty: 'max-height, height, opacity',
						transitionDuration: theme.animation.timing400,
						transitionTimingFunction: theme.animation.easeInOutCurve,
					},
				},
				toggleIcon: {
					color: theme.colors.accent50,
					fill: theme.colors.accent50,
					stroke: theme.colors.accent50,
				},
			}}
		>
			<Panel
				key={id}
				title={
					<span
						className={css({
							fontSize: '0.875rem',
							fontWeight: 400,
							color: theme.colors.accent50,
							marginLeft: '0.875rem',
						})}
					>
						{title}
					</span>
				}
			>
				{children}
			</Panel>
		</ENGTAccordion>
	);
};

export default AccordionNavGroup;
